import React, { useEffect, useRef } from "react";
import OcrLayout from "./components/layout/OcrLayout.jsx";
import NavPage from "./components/features/Nav.jsx";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import navItemsTest from './const/menu.json';
import { getProductList } from './api';
import { getQueryString, checkIsInWhite } from './utils/index';
import { useMenuStore, useUIStore } from './store';
import { initializeCacheCleanup } from './cache';
import { isTestEnv } from './config';

function Home() {
  // 从 store 获取状态和方法
  const {
    action,
    navItems,
    setAction,
    setCurrentMenu,
    setNavItems
  } = useMenuStore();

  const { pageLoading, setPageLoading } = useUIStore();

  // 使用 useRef 来保存最新的状态值（用于事件监听器）
  const navItemsRef = useRef(navItems);

  // 更新 ref 的值
  useEffect(() => {
    navItemsRef.current = navItems;
  }, [navItems]);

  useEffect(() => {
    async function func() {
      setPageLoading(true);
      const actionParam = getQueryString('action');
      setAction(actionParam);
      const res = await getProductList();
      setPageLoading(false);

      if (res?.config?.defaultConfig) {
        // 测试环境使用本地配置，正式环境使用接口返回的配置
        // let _navItems = isTestEnv
        //   ? navItemsTest.defaultConfig
        //   : res?.config?.defaultConfig;
        let _navItems = res?.config?.defaultConfig;
        let _whiteList = [];
        _navItems.flat().forEach(i => {
          i.children.forEach(c => {
            if (c.whiteList?.length > 0) {
              _whiteList = _whiteList.concat(c.whiteList);
            }
          });
        });
        const whiteListRule = _whiteList.length <= 0 ? {} : await checkIsInWhite(_whiteList);

        _navItems = _navItems.flat().map(i => {
          return {
            ...i,
            children: i.children.filter(c => {
              // 配置了直接不显示
              if (typeof (c.IsHide) === 'boolean') {
                return !c.IsHide;
                // 配置通过白名单显示
              } else if (typeof (c.IsHide) === 'object') {
                return whiteListRule[c.IsHide]?.length > 0;
              } else {
                return true;
              }
            }).map(child => {
              return {
                ...child,
                menuKey: i.key
              };
            })
          };
        });
        setNavItems(_navItems);
        delCurrentMenu(actionParam, _navItems);
      }
    }
    func();
  }, []);

  // 监听路由search中action参数的变化
  useEffect(() => {
    const handleRouteChange = () => {
      const currentAction = getQueryString('action');
      if (currentAction) {
        delCurrentMenu(currentAction, navItemsRef.current);
      }
    };

    // 监听popstate事件（浏览器前进后退）
    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  // 页面首次加载时，异步清理过期缓存（不影响渲染）
  useEffect(() => {
    initializeCacheCleanup();
  }, []);

  const delCurrentMenu = (actionParam, menuItems = navItems) => {
    const list = menuItems?.map(i => i.children).flat();
    const result = list?.find(i => {
      return i.action === actionParam;
    });
    if (result) {
      setAction(result.action);
      setCurrentMenu(result);
    }
  };

  const handleChangeAction = (actionParam) => {
    delCurrentMenu(actionParam, navItems);
    window.location.search = `action=${actionParam}`;
  };

  return (
    <>
      <Router>
        <Switch>
          <Route path="/">
            {
              pageLoading ? <></> : <>
                {action ? <OcrLayout
                  onChangeAction={handleChangeAction}
                /> : <NavPage
                  navList={navItems}
                  onChangeAction={(actionParam) => {
                    window.location.search = `action=${actionParam}`;
                  }} />}
              </>
            }
          </Route>
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default Home;
